import React, { useEffect, useRef } from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4charts from '@amcharts/amcharts4/charts';

am4core.useTheme(am4themes_animated);

const GapAnalysisGraph = ({ data = []}) => {
  const chartDivRef = useRef(null);

  // Calculate dynamic height based on data length
  const dataLength = data?.length || 0;
  const dynamicHeight = Math.max(dataLength * 50, 300);  // Minimum 300px, 50px per data item

  useEffect(() => {
    if (!data || data.length === 0) return ;
    const chart = am4core.create(chartDivRef.current, am4charts.XYChart);
    chart.hiddenState.properties.opacity = 0; // initial fade-in effect

    // Preprocess data to add 'gap' field
    chart.data = data.map(item => ({
      category: item.category,
      score: parseFloat(item.score), // Assuming 'score' is in your data
      gap: 100 - parseFloat(item.score)  // Calculate gap as 100 - score
    }));

    chart.colors.step = 2;

    chart.legend = new am4charts.Legend();
    chart.legend.position = 'top';
    chart.legend.paddingBottom = 10;
    chart.legend.labels.template.maxWidth = 95;

    // Y-axis: Category Axis (now on Y-axis instead of X)
    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.location = 0;

    // X-axis: Value Axis (now on X-axis instead of Y)
    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;  // Explicitly set max value to 100
    valueAxis.strictMinMax = true;  // Ensure strict adherence to min and max values
    valueAxis.renderer.minWidth = 50; // Ensure axis has a minimum width for rendering
    // valueAxis.renderer.maxLabelPosition = 0.98;  // To avoid the labels being cut off at the top

    // Function to create series with totalPercent values
    function createSeries(name, field, color) {
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.columns.template.height = am4core.percent(80); // Adjust height for horizontal bars
      series.columns.template.tooltipText = "{name}: {valueX.formatNumber('#.')}%"; // Tooltip (show score or gap value)
      series.name = name;
      series.dataFields.categoryY = "category";  // Change to categoryY for vertical axis
      series.dataFields.valueX = field;         // Change to valueX for horizontal axis
      series.dataItems.template.locations.categoryY = 0.5;
      series.stacked = true;
      series.tooltip.pointerOrientation = "horizontal"; // Pointer orientation for horizontal bars

      // Set the color for the series
      series.columns.template.fill = am4core.color(color);

      var bullet = series.bullets.push(new am4charts.LabelBullet());
      bullet.interactionsEnabled = false;
      bullet.label.text = "{valueX.formatNumber('#.')}%"; // Show percentage or value directly
      bullet.locationX = 0.5; // Adjust the label to center
      bullet.label.fill = am4core.color("#ffffff");
    }

    // Create series for Score and GAP with colors
    createSeries("Score", "score", "#4CAF50");  // Green for Score
    createSeries("GAP", "gap", "#ff0000");     // Red for GAP

    // Cleanup function
    return () => {
      chart.dispose();
    };
  }, [data]);

  return (
    <div className="card shadow mb-2">
      <div className='integrated-dashboard-bg'>
        {/* <p className="carousel-title">Gap Analysis By Main Controls</p> */}
        <div className="card-header py-2">
          <h6 className="m-0 font-weight-bold text-primary">Gap Analysis By Main Controls</h6>
        </div>
        {data.length > 0 ? (
          <div>
            <div ref={chartDivRef} id="threat-chartdiv" className="threat-actor-data" style={{ height: `${dynamicHeight}px` }}></div>
          </div>
        ):
        (
          <div className='center-content'><h5>Please complete at least one Assessment to view Dashboard</h5></div>
        )}
      </div>
    </div>

  );
};

export default GapAnalysisGraph;
